import React from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
// Include the locale utils designed for moment
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

// Make sure moment.js has the required locale data
import 'moment/locale/de';
import 'react-day-picker/lib/style.css'

export default ({name,value,onChange,valid,invalid,size,inputStyle}) =>
  <DayPickerInput
    value={value || ''}
    formatDate={formatDate}
    parseDate={parseDate}
    localeUtils={MomentLocaleUtils}
    locale="de"
    inputProps={{
      className:`${size ? 'form-control-'+size : ''}  form-control ${valid===true ? 'is-valid' : ''} ${invalid===true ? 'is-invalid' : ''}`,
      placeholder: 'dd.mm.JJJJ',
      style: inputStyle
    }}
    onDayChange={(newDate) => onChange({target: {name, value: newDate}})}
    dayPickerProps={{
      locale: 'de',
      localeUtils: MomentLocaleUtils,
    }}/>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/DatePicker.js